import { ComponentProps, ReactNode } from "react";
import * as S from "./styles";
import { v4 } from "uuid";

export interface ITableItemProps extends ComponentProps<"div"> {
  values?: string[];
  headers: string[];
  columns: string;
  elements?: ReactNode[];
  lastElement?: ReactNode;
}

export const TableItemWithHeader = ({
  values,
  lastElement,
  headers,
  elements,
  ...rest
}: ITableItemProps) => {
  return (
    <S.CustomTableItem {...{ values, headers, lastElement, ...rest }}>
      {headers?.length > 0 &&
        headers.map((i, idx) => (
          <div key={v4()}>
            <p>{i}</p>
            <span>{values[idx]}</span>
          </div>
        ))}

      {elements?.length > 0 && elements.map((i) => i)}
      {lastElement && lastElement}
    </S.CustomTableItem>
  );
};
